if (!customElements.get('ht-tabs')) {
  class HtTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.ink = this.querySelector('.ht-tabs__ink');

      this.addEventListener('click', this.#onClick);
      window.addEventListener('resize', this.#moveInk);
      requestAnimationFrame(this.#moveInk);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      window.removeEventListener('resize', this.#moveInk);
    }

    #onClick = (event) => {
      const tab = event.target.closest('[data-tab]');
      if (!tab) return;
      const index = tab.dataset.tab;
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      this.panels.forEach((panel) => {
        const on = panel.dataset.panel === index;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
      this.#moveInk();
    };

    #moveInk = () => {
      const active = this.querySelector('.ht-tabs__tab.is-active');
      if (!active || !this.ink) return;
      this.ink.style.width = `${active.offsetWidth}px`;
      this.ink.style.transform = `translateX(${active.offsetLeft}px)`;
    };
  }

  customElements.define('ht-tabs', HtTabs);
}
